export enum StockMovementType {
  PURCHASE = "PURCHASE",
  ISSUE = "ISSUE",
  TRANSFER = "TRANSFER",
  RETURN = "RETURN",
  ADJUSTMENT = "ADJUSTMENT",
}

export const StockMovementTypeLabel: Record<StockMovementType, string> = {
  [StockMovementType.PURCHASE]: "Purchase",
  [StockMovementType.ISSUE]: "Issue",
  [StockMovementType.TRANSFER]: "Transfer",
  [StockMovementType.RETURN]: "Return",
  [StockMovementType.ADJUSTMENT]: "Adjustment",
};
